import Clone from '@apps/truevail/admin/views/admin/templates/clone'
import New from '@apps/truevail/admin/views/admin/templates/new'
import TemplateToken from '@apps/truevail/admin/tokens/template'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Embeds)',
  collection: {
    endpoint: '/api/admin/truevail/admin/templates/embed',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', format: (template) => (
        <TemplateToken template={ template } show_provider={ false } show_voice={ true } />
      ) }
    ],
    empty: {
      icon: 'code',
      title: 't(No Embeds)',
      text: 't(There are no embeds for this form)',
      buttons: [
        { 
          label: 't(Create Embed)', 
          modal: {
            component: <New type="embed" form={ props.form } />,
            options: { width: 1168 }
          }
        }
      ]
    },
    defaultQuery: { form_id: props.form.id },
    defaultSort: { key: 'created_at', order: 'desc' },
    entity: 'embed',
    recordTasks: (record) => [
      {
        label: 't(Duplicate Embed)',
        svg: 'copy',
        modal: <Clone form={ props.form } embed={ record } /> 
      },
      {
        label: 't(Delete Embed)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this embed?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/templates/${record.id}`,
          method: 'DELETE',
          onSuccess: () => context.flash.set('success', 't(Successfully deleted form)'),
          onFailure: () => context.flash.set('error', 't(Unable to delete form)')
        }
      }
    ],
    onClick: (record) => context.router.push(`/admin/truevail/admin/templates/${record.id}`)
  },
  task: {
    svg: 'plus',
    tooltip: 't(Create Embed)', 
    modal: {
      component: <New type="embed" form={ props.form } />,
      options: { width: 1168 }
    }
  }
})

export default Panel(null, mapPropsToPanel)
